import { Vue, Component } from 'vue-property-decorator'
import Axios from 'axios'

@Component
export default class DashboardPageComponent extends Vue {
  title: string = ''
  ruc: string = ''
  onLogOut () {
    sessionStorage.removeItem('token')
    this.$router.push('/login')
  }

  mounted () {
    this.getEnterprise()
  }

  getEnterprise () {
    const ruc = (document.head.querySelector('meta[name="ruc"]') as any).content
    Axios.get(`/enterprise/${ruc}`).then(response => {
      this.title = response.data.emi_nombre_comercial
      this.ruc = response.data.emi_ruc
    })
  }
}
